/**
 * Check if a description string contains a specific month and year pattern
 * Optimized version with cached string operations
 * @param {string} d - Description string to check
 * @param {string} month - Month name to search for
 * @param {object} year - Dayjs object representing the year
 * @returns {boolean} - Whether the pattern was found
 */
export const yearCheck = (d, month, year) => {
  const desc = d.toLowerCase();
  const monthLower = month.toLowerCase();
  const month3 = month.substr(0, 3).toLowerCase();
  const month4 = month.substr(0, 4).toLowerCase();
  const yyyy = year.format("YYYY");
  const yy = year.format("YY");

  // Build regex for common patterns
  const patterns = [
    `tithing${monthLower}${yyyy}`,
    `tithe${monthLower}${yyyy}`,
    `tithing${month4}${yyyy}`,
    `tithe${month4}${yyyy}`,
    `tithing${month4}${yy}`,
    `tithe${month4}${yy}`,
    `tithing${month3}${yy}`,
    `tithe${month3}${yy}`,
    `${monthLower}${yyyy}`,
    `${month4}${yyyy}`,
    `${month4}${yy}`,
    `${month3}${yyyy}`,
    `${month3}${yy}`,
    `${month3} ${yy}`,
    `${month3} ${yyyy}`,
    `${monthLower} ${yy}`,
    `${monthLower} ${yyyy}`,
    `${month3}-${yy}`,
    `${month3}-${yyyy}`,
  ];

  return patterns.some((pattern) => desc.includes(pattern));
};

// Legacy version kept for backward compatibility
export const yearCheckLegacy = (d, month, year) => {
  return (
    d.toLowerCase().indexOf(
      ` tithing${month.toLowerCase()}${year.format("YYYY").toString()} `, // ' tithingjanuary2024
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithing${month.toLowerCase()}${year.format("YYYY").toString()} `, // 'tithingjanuary2024
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` tithe${month.toLowerCase()}${year.format("YYYY").toString()} `, // ' tithejanuary2024'
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithe${month.toLowerCase()}${year.format("YYYY").toString()} `, // 'tithejanuary2024'
    ) > -1 ||
    d
      .toLowerCase()
      .indexOf(` ${month.toLowerCase()}${year.format("YYYY").toString()}-`) > // ' january2024-'
      -1 ||
    d
      .toLowerCase()
      .indexOf(` ${month.toLowerCase()}${year.format("YYYY").toString()} `) > // ' january2024 '
      -1 ||
    d
      .toLowerCase()
      .indexOf(`-${month.toLowerCase()}${year.format("YYYY").toString()} `) > // '-january2024 '
      -1 ||
    d.toLowerCase().indexOf(
      ` tithing${month.substr(0, 4).toLowerCase()}${year
        .format("YYYY")
        .toString()} `, // ' tithingjanu2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithing${month.substr(0, 4).toLowerCase()}${year
        .format("YYYY")
        .toString()} `, // 'tithingjanu2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` tithe${month.substr(0, 4).toLowerCase()}${year
        .format("YYYY")
        .toString()} `, // ' tithejanu2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithe${month.substr(0, 4).toLowerCase()}${year
        .format("YYYY")
        .toString()} `, // 'tithejanu2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 4).toLowerCase()}${year.format("YYYY").toString()} `, // ' janu2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 4).toLowerCase()}${year.format("YYYY").toString()}-`, // ' janu2024-'
    ) > -1 ||
    d.toLowerCase().indexOf(
      `-${month.substr(0, 4).toLowerCase()}${year.format("YYYY").toString()} `, // '-janu2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` tithing${month.substr(0, 4).toLowerCase()}${year
        .format("YY")
        .toString()} `, // ' tithingjanu24'
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithing${month.substr(0, 4).toLowerCase()}${year
        .format("YY")
        .toString()} `, // 'tithingjanu24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` tithe${month.substr(0, 4).toLowerCase()}${year
        .format("YY")
        .toString()} `, // ' tithejanu24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithe${month.substr(0, 4).toLowerCase()}${year
        .format("YY")
        .toString()} `, // 'tithejanu24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 4).toLowerCase()}${year.format("YY").toString()} `, // ' janu24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 4).toLowerCase()}${year.format("YY").toString()}-`, // ' janu24-'
    ) > -1 ||
    d.toLowerCase().indexOf(
      `-${month.substr(0, 4).toLowerCase()}${year.format("YY").toString()} `, // '-janu24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` tithing${month.substr(0, 3).toLowerCase()}${year
        .format("YY")
        .toString()} `, // ' tithingjan24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithing${month.substr(0, 3).toLowerCase()}${year
        .format("YY")
        .toString()} `, // 'tithingjan24'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` tithe${month.substr(0, 3).toLowerCase()}${year
        .format("YY")
        .toString()} `, // ' tithejan24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      `tithe${month.substr(0, 3).toLowerCase()}${year
        .format("YY")
        .toString()} `, // 'tithejan24'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()}${year.format("YY").toString()} `, // ' jan24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()}${year.format("YY").toString()}-`, // ' jan24-'
    ) > -1 ||
    d.toLowerCase().indexOf(
      `-${month.substr(0, 3).toLowerCase()}${year.format("YY").toString()} `, // '-jan24'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()} ${year.format("YY").toString()} `, // ' jan 24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()} ${year.format("YYYY").toString()} `, // ' jan 2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.toLowerCase()} ${year.format("YY").toString()} `, // ' january 24 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.toLowerCase()} ${year.format("YYYY").toString()} `, // ' january 2024 '
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()}${year.format("YY").toString()} `, // 'jan24'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()}${year.format("YYYY").toString()} `, // 'jan2024'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()} ${year.format("YYYY").toString()} `, // 'jan 2024'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()}-${year.format("YY").toString()} `, // 'jan-24'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.substr(0, 3).toLowerCase()}-${year.format("YYYY").toString()} `, // 'jan-2024'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.toLowerCase()} ${year.format("YY").toString()} `, // 'january 24'
    ) > -1 ||
    d.toLowerCase().indexOf(
      ` ${month.toLowerCase()} ${year.format("YYYY").toString()} `, // 'january 2024'
    ) > -1
  );
};

/**
 * Search for members by memberID in description
 * Optimized with early returns and cleaner logic
 * @param {string} desc - Description to search in
 * @param {Array} members - Array of member objects
 * @returns {Array|null} - Matching members or null
 */
export const memberIDSearch = (desc, members) => {
  if (!desc || !members) return null;

  const descLower = desc.toLowerCase();
  const matches = members.filter(
    (member) =>
      member.memberID &&
      member.memberID.length > 5 &&
      descLower.includes(member.memberID.toLowerCase()),
  );

  return matches.length > 0 ? matches : null;
};

/**
 * Clean and normalize name string
 * Helper function for name matching
 */
const cleanName = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/[,\-()]/g, " ")
    .split(" ")
    .filter((word) => word && !word.includes("."))
    .join(" ");
};

/**
 * Search for members by name and description, with exception handling
 * Optimized version with better performance and cleaner logic
 * @param {string} desc - Description to search in
 * @param {string} name - Name to search for
 * @param {Array} members - Array of member objects
 * @param {Array} exceptions - Array of exception objects
 * @returns {Array|null|string} - Matching members, exception action, or null
 */
export const memberSearch = (desc, name, members, exceptions) => {
  if (!members || (!desc && !name)) return null;

  const descLower = desc && desc.toLowerCase();
  const nameLower = name && name.toLowerCase();

  // Step 1: Quick memberID check
  if (desc) {
    const membersByID = members.filter(
      (member) =>
        member.memberID &&
        member.memberID.length > 5 &&
        descLower.includes(member.memberID.toLowerCase()),
    );

    if (membersByID.length === 1) return membersByID;
    if (membersByID.length > 1 && name) return null;
    if (membersByID.length > 0) return membersByID;
  }

  // Step 2: Check exceptions
  if (exceptions) {
    const matchedException = exceptions.find((exception) => {
      const exceptionLower = exception.name.toLowerCase();
      return (
        (desc && descLower.includes(exceptionLower)) ||
        (name && nameLower.includes(exceptionLower))
      );
    });

    if (matchedException && matchedException.action) {
      const membersByIDException = members.filter(
        (member) =>
          member.memberID &&
          member.memberID.length > 5 &&
          matchedException.action.includes(member.memberID.toLowerCase()),
      );

      if (membersByIDException.length === 1) return membersByIDException;
      if (membersByIDException.length > 1 && name) return null;
      if (membersByIDException.length > 0) return membersByIDException;
    }
  }

  // Step 3: Name matching
  if (!name) return null;

  const cleanedName = cleanName(name);
  const nameParts = cleanedName.split(" ").filter(Boolean);

  if (nameParts.length <= 1) return null;

  // Filter and sort matching members
  const matchingMembers = members
    .filter((member) => {
      if (!member.firstName || !member.lastName) return false;

      const firstName = cleanName(member.firstName);
      const lastName = cleanName(member.lastName);

      const firstNameParts = firstName.split(" ");
      const lastNameParts = lastName.split(" ");
      const totalParts = firstNameParts.length + lastNameParts.length;

      // Count matching parts
      const matchCount = nameParts.filter(
        (part) =>
          ` ${firstName} `.includes(` ${part} `) ||
          ` ${lastName} `.includes(` ${part} `),
      ).length;

      const requiredMatches = Math.min(nameParts.length, totalParts);
      return matchCount >= requiredMatches;
    })
    .sort(
      (a, b) =>
        `${b.firstName} ${b.lastName}`.length -
        `${a.firstName} ${a.lastName}`.length,
    );

  if (matchingMembers.length === 0) return null;
  if (matchingMembers.length === 1) return matchingMembers;

  // If multiple matches, filter by highest word count
  const maxWords = Math.max(
    ...matchingMembers.map(
      (m) => `${m.firstName} ${m.lastName}`.split(" ").length,
    ),
  );

  const bestMatches = matchingMembers.filter(
    (m) => `${m.firstName} ${m.lastName}`.split(" ").length === maxWords,
  );

  return bestMatches.length === 1 ? bestMatches : null;
};
